import { render, staticRenderFns } from "./QuestionList.vue?vue&type=template&id=08f5dabe&scoped=true&style=width%3A%20100%25"
import script from "./QuestionList.vue?vue&type=script&lang=ts"
export * from "./QuestionList.vue?vue&type=script&lang=ts"
import style0 from "./QuestionList.vue?vue&type=style&index=0&id=08f5dabe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5dabe",
  null
  
)

export default component.exports